import { create } from 'zustand';
import { skuService, type SKUData, type SKUSingle, type GetSKUDataResponse } from '../services/skuService';

interface SKUState {

  saveSKU: (skuData: SKUData) => Promise<any>;
  getListSkus: (params?: { page?: number; page_size?: number; search?: string }) => Promise<any>;
  saveSingleSKU: (skuData: SKUSingle) => Promise<any>;
  updateSKU: (skuId: string, skuData: Omit<SKUData, 'file'>) => Promise<any>;
  deleteSKU: (skuId: string | string[]) => Promise<any>;
  getSKU: (skuId: string) => Promise<{ success: boolean; message: string, data?: GetSKUDataResponse }>;
}

export const useSKUStore = create<SKUState>(() => ({

  saveSKU: async (skuData: SKUData) => {
    try {
      const result = await skuService.saveSKU(skuData);
      return result
    } catch (error) {

      return false;
    }
  },
  getListSkus: async (params?: { page?: number; page_size?: number; search?: string }) => {
    try {
      const response = await skuService.getSKUList(params);
      return response;
    } catch (error) {
      console.error('Error fetching SKUs:', error);
      throw error;
    }
  },
  saveSingleSKU: async (skuData: SKUSingle) => {
    try {
      const result = await skuService.saveSingleSKU(skuData);
      return result;
    } catch (error) {
      return false;
    }
  },
  updateSKU: async (skuId: string, skuData: Omit<SKUData, 'file'>) => {
    try {
      const result = await skuService.updateSKU(skuId, skuData);
      return result;
    } catch (error) {
      return false;
    }
  },
  deleteSKU: async (skuId: string | string[]) => {
    try {
      if (Array.isArray(skuId)) {
        const result = await skuService.deleteSKUs(skuId);
        return result;
      }
      const result = await skuService.deleteSKU(skuId);
      return result;
    } catch (error) {
      return false;
    }
  },
  getSKU: async (skuId: string): Promise<{ success: boolean; message: string, data?: GetSKUDataResponse }> => {
    try {
      const result = await skuService.getSKU(skuId);
      return result;
    } catch (error) {
      return {
        success: false,
        message: 'Error al obtener SKU',
      };
    }
  },
}));
